import React from "react";
import ReactGA from "react-ga";
import { Grid, Divider } from "@material-ui/core";
import RemoteStatus from "../RemoteStatus";
import AboutCo from "../AboutCo";
import CompanyRegionality from "../../../Components/CompanyRegionality";

export default function OverviewSubpage({
  alwaysBeenRemote,
  companyName,
  hq,
  employees,
  website,
  about,
  founded,
  remoteData,
  remoteSinceDate,
  remoteUntil,
  remotePolicy,
  policyDuration,
  perm,
  loading
}) {
  const { jobsLink = "" } = remoteData ? remoteData : {};
  if (companyName) {
    ReactGA.pageview(`company/${companyName}/overview`);
  }

  let remoteUntilDate = loading ? null : remoteUntil.toDate();

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <AboutCo
            companyName={companyName}
            hq={hq}
            employees={employees}
            website={website}
            about={about}
            founded={founded}
            jobsLink={jobsLink}
            loading={loading}
          />
          <Divider variant="middle" light />
        </Grid>
        <Grid item xs={12}>
          <RemoteStatus
            remoteSince={remoteSinceDate}
            remoteUntil={remoteUntilDate}
            perm={perm}
            remotePolicy={remotePolicy}
            companyName={companyName}
            alwaysBeenRemote={alwaysBeenRemote}
            policyDuration={policyDuration}
            loading={loading}
          />
          <Divider variant="middle" light />
        </Grid>
        <CompanyRegionality
          companyName={companyName}
          numEmployees={employees}
          loading={loading}
        />
      </Grid>
      {/* <CoRemoteWorkTools /> */}
    </>
  );
}
